import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendGroceryReceiptEmail = async ({ orderId, emailAddress }: { orderId: string; emailAddress?: string }) => {
  const response = await mutationExecute({
    variables: {
      orderId,
      emailAddress,
    },
    mutation: graphql(`
      mutation SendGroceryReceiptEmail($orderId: String!, $emailAddress: String) {
        sendGroceryReceiptEmail(orderId: $orderId, emailAddress: $emailAddress)
      }
    `),
  });

  return response.data?.sendGroceryReceiptEmail ?? false;
};
